import React, { Component } from "react";
import withStyles from '@mui/styles/withStyles';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

import { Colors } from "config/StyleConfig";
import Checkbox from "@mui/material/Checkbox";

const styles = () => ({
  root: {
    "&$checked": {
      color: Colors.secondary,
    },
  },
  checked: {},
});

class CheckboxWrapper extends Component {
  render() {
    const { classes } = this.props;

    return (
      <Checkbox
        classes={{
          root: classes.root,
          checked: classes.checked,
        }}
        icon={<CheckBoxOutlineBlankIcon />}
        checkedIcon={<CheckBoxIcon />}
        style={{ marginRight: 8 }}
        size="small"
        {...this.props}
      />
    );
  }
}

export default withStyles(styles)(CheckboxWrapper);
